import { API_NO_ACCESS } from 'self-service-api/constants/FreeUserAccessValues';
import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
// @ts-expect-error Could not find a declaration file for module
import { getUserLanguage } from 'self-service-api/api/getUserLanguage';
import { getProductLevelFromApiNameString } from '../_core/features/FeaturesUtils';
export const sortApiNamesByProductLevel = apiNames => {
  const copy = [...apiNames];
  copy.sort((a, b) => {
    return currentOrderedProductLevels.indexOf(getProductLevelFromApiNameString(a)) - currentOrderedProductLevels.indexOf(getProductLevelFromApiNameString(b));
  });
  return copy;
};
export const getFeatureTableTooltipKey = (canViewNewSeats, freeUserAccess, productLine) => {
  if (freeUserAccess === API_NO_ACCESS) {
    if (!canViewNewSeats) {
      return `upgrades.featureTable.freeUser.NO_ACCESS`;
    }
    switch (productLine) {
      case 'SALES':
        return `upgrades.featureTable.freeUserSeats.NO_ACCESS.SALES`;
      case 'SERVICE':
        return `upgrades.featureTable.freeUserSeats.NO_ACCESS.SERVICE`;
      default:
        return `upgrades.featureTable.freeUserSeats.NO_ACCESS.default`;
    }
  }
  if (!canViewNewSeats) {
    return `upgrades.featureTable.freeUser.LIMITED_ACCESS`;
  }
  switch (productLine) {
    case 'SALES':
      return `upgrades.featureTable.freeUserSeats.LIMITED_ACCESS.SALES`;
    case 'SERVICE':
      return `upgrades.featureTable.freeUserSeats.LIMITED_ACCESS.SERVICE`;
    default:
      return `upgrades.featureTable.freeUserSeats.LIMITED_ACCESS.default`;
  }
};
export const filterFeaturesHiddenFromLang = features => {
  const languageToFilter = getUserLanguage();
  return features.filter(feature => {
    const {
      hideFromLang
    } = feature;
    return hideFromLang ? hideFromLang !== languageToFilter : true;
  });
};